/**
 * Vanilla carousels (replaces jQuery + Slick). Initializes [data-sweetums-carousel].
 */
(function () {
  'use strict';

  function readInt(el, name, fallback) {
    var v = el.getAttribute(name);
    if (v == null || v === '') return fallback;
    var n = parseInt(v, 10);
    return Number.isNaN(n) ? fallback : n;
  }

  function getVisibleCount(root) {
    var w = window.innerWidth;
    if (w >= 990) return readInt(root, 'data-slides-desktop', 1);
    if (w >= 750) return readInt(root, 'data-slides-tablet', 1);
    return readInt(root, 'data-slides-mobile', 1);
  }

  function getGapPx(track) {
    var g = window.getComputedStyle(track).gap;
    if (g && g.indexOf('px') !== -1) return parseFloat(g) || 0;
    return 0;
  }

  function initCarousel(root) {
    if (root.getAttribute('data-sweetums-carousel-ready') === '1') return;

    var track = root.querySelector('.sweetums-carousel__track');
    var viewport = root.querySelector('.sweetums-carousel__viewport');
    if (!track || !viewport) return;

    var slides = track.querySelectorAll('.sweetums-carousel__slide');
    if (!slides.length) return;

    root.setAttribute('data-sweetums-carousel-ready', '1');

    var dotsEnabled = root.getAttribute('data-dots') === 'true';
    var dotsRoot = root.querySelector('.sweetums-carousel__dots');
    var prevBtn = root.querySelector('[data-carousel-prev]');
    var nextBtn = root.querySelector('[data-carousel-next]');

    function applyVisible() {
      var v = Math.max(1, getVisibleCount(root));
      root.style.setProperty('--carousel-visible', String(v));
    }

    function slideStepPx() {
      var gap = getGapPx(track);
      var first = slides[0];
      if (!first) return 0;
      return first.getBoundingClientRect().width + gap;
    }

    function maxScrollLeft() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function goByDirection(dir) {
      var step = slideStepPx();
      if (step <= 0) return;
      track.scrollBy({ left: dir * step, behavior: 'smooth' });
    }

    function goToIndex(index) {
      var step = slideStepPx();
      if (step <= 0) return;
      var clamped = Math.max(0, Math.min(slides.length - 1, index));
      track.scrollTo({ left: clamped * step, behavior: 'smooth' });
    }

    function syncChrome() {
      var max = maxScrollLeft();
      var left = track.scrollLeft;
      if (prevBtn) prevBtn.disabled = left <= 2;
      if (nextBtn) nextBtn.disabled = left >= max - 2;

      if (dotsEnabled && dotsRoot) {
        var step = slideStepPx();
        if (step > 0) {
          var idx = Math.round(left / step);
          idx = Math.max(0, Math.min(idx, dotsRoot.children.length - 1));
          for (var i = 0; i < dotsRoot.children.length; i++) {
            dotsRoot.children[i].classList.toggle('is-active', i === idx);
          }
        }
      }
    }

    function buildDots() {
      if (!dotsEnabled || !dotsRoot) return;
      dotsRoot.innerHTML = '';
      for (var i = 0; i < slides.length; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sweetums-carousel__dot';
        b.setAttribute('aria-label', 'Slide ' + (i + 1) + ' of ' + slides.length);
        (function (ix) {
          b.addEventListener('click', function () {
            goToIndex(ix);
          });
        })(i);
        dotsRoot.appendChild(b);
      }
    }

    applyVisible();
    buildDots();

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goByDirection(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goByDirection(1);
      });
    }

    track.addEventListener(
      'scroll',
      function () {
        syncChrome();
      },
      { passive: true }
    );

    window.addEventListener(
      'resize',
      function () {
        applyVisible();
        window.requestAnimationFrame(syncChrome);
      },
      { passive: true }
    );

    syncChrome();
  }

  function scan() {
    document.querySelectorAll('[data-sweetums-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', scan);
})();
